const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
const STATES = [
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'CA', name: 'California' },
  { code: 'TX', name: 'Texas' },
  { code: 'FL', name: 'Florida' },
  { code: 'NY', name: 'New York' },
  { code: 'IL', name: 'Illinois' },
  { code: 'OH', name: 'Ohio' },
  { code: 'GA', name: 'Georgia' },
  { code: 'WA', name: 'Washington' },
  { code: 'MI', name: 'Michigan' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'VA', name: 'Virginia' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'CO', name: 'Colorado' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'IN', name: 'Indiana' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MD', name: 'Maryland' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'AL', name: 'Alabama' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'OR', name: 'Oregon' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'UT', name: 'Utah' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'ID', name: 'Idaho' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ME', name: 'Maine' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'DE', name: 'Delaware' }
];

const monthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];



const automationRoute = `${API_BASE_URL}/api/automation/run`;
const propertiesRoute = `${API_BASE_URL}/api/properties`;
const rawPropertiesRoute = `${API_BASE_URL}/api/properties/raw`;
const loginRoute = `${API_BASE_URL}/api/auth/login`;
const userRoute = `${API_BASE_URL}/api/user`;
const verifyRoute = `${API_BASE_URL}/api/auth/verify`;

export { STATES, automationRoute, propertiesRoute, loginRoute, userRoute, monthNames, verifyRoute, API_BASE_URL, rawPropertiesRoute};